import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

const MiniGlobeItem = (props) => {
  const popover = (
    <Popover id="popover-basic" className="mini-globe-popup">
      <div className="globe-popup-body">
        <div className="popup-content-wrapper">
          <div className="connecting-line"></div>
          <div className="mg-text-wrapper">
            <div className="mini-globe-text">{props.linkData.displayName}</div>
          </div>
        </div>
      </div>
    </Popover>
  );
  return (
    <div
      className="mini-satellite-outer-ring "
      onClick={() => {
        props.openLerarningLink(props.linkData);
        window.open(props.linkData.link, "_blank");
      }}
    >
      <OverlayTrigger
        trigger={["hover", "focus", "click"]}
        placement="right-end"
        overlay={popover}
        rootClose
      >
        <div className="mini-satellite "></div>
      </OverlayTrigger>
    </div>
  );
};

export default MiniGlobeItem;
